/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { UserCell } from "UpduoLibrary";

interface UserCompleteCellProps {
  rowData: any;
  isIncomplete: boolean;
  role: string;
}

export default function UserCompleteCell({
  rowData,
  isIncomplete,
  role,
}: UserCompleteCellProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: 340,
      }}
    >
      <View style={{ minWidth: 185, marginRight: 5 }}>
        <UserCell
          user={rowData[role]}
          summit={
            role === "learner" ? rowData.learnerSummit : rowData.teacherSummit
          }
          isIncomplete={isIncomplete}
          isGraphql={true}
          orgType={"C"}
        />
      </View>
    </View>
  );
}
